<style lang="less" scoped>
.margin-left-15 {
  margin-left: 15px;
}
.detail-form-parent-child-div {
  margin-top: 10px;
  align-items: center;
}
.detail-form-parent-title-div {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  width: 120px;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form
          :model="detailForm"
          :rules="pageConfig.formRules"
          ref="detailForm"
          label-width="120px"
          class="detail-form"
        >
          <div class="flex detail-form-parent-div">
            <div class="flex-1">
              <el-form-item label="IMEI号" prop="pileCode">
                <el-input
                  v-model="detailForm.pileCode"
                  size="small"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="充电桩型号名称" prop="pileTypeCode">
                <el-select
                  class="full-width"
                  v-model="detailForm.pileTypeCode"
                  size="small"
                  clearable
                  @change="hadlePileTypeChange"
                >
                  <el-option
                    v-for="item in pileTypes"
                    :label="item.pileTypeName"
                    :value="item.pileTypeCode"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="电流输出类型" prop="currentOutTypeName">
                <el-select
                  class="full-width"
                  v-model="detailForm.currentOutTypeName"
                  size="small"
                  disabled
                >
                  <el-option
                    v-for="item in currentOuts"
                    :label="item.configName"
                    :value="item.configVal"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="充电枪数量" prop="gunNum">
                <el-input
                  v-model="detailForm.gunNum"
                  size="small"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="计费方式" prop="">
                <el-select class="full-width" v-model="detailForm.calcWay" size="small" clearable @change="handleSourceChange">
                  <el-option v-for="item in calcList"
                             :label="item.configName"
                             :value="item.configVal"
                             :key="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="产品编号" prop="productNo">
                <el-input
                  v-model="detailForm.productNo"
                  size="small"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="资费（元/度）">
                                <el-input v-model="detailForm.ttlVal" size="small" disabled></el-input>
                            </el-form-item> -->
            </div>
            <div class="flex-1">
              <el-form-item label="所属经销商" prop="dealName">
                <el-select
                  class="full-width"
                  v-model="detailForm.dealName"
                  size="small"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in dealers"
                    :label="item.dealName"
                    :value="item.dealNo"
                    :key="item.dealNo"
                    @click.native="handleDealChange(item)"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="充电桩类型" prop="optType">
                <el-select
                  class="full-width"
                  v-model="detailForm.optType"
                  size="small"
                  clearable
                >
                  <el-option
                    v-for="item in optTypes"
                    :label="item.configName"
                    :value="item.configVal"
                    :key="item.id"
                    @click.native="handleOptChange(item)"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="充电速度" prop="chargingSpeed">
                <el-select
                  class="full-width"
                  v-model="detailForm.chargingSpeed"
                  size="small"
                  disabled
                >
                  <el-option
                    v-for="item in chargingSpeeds"
                    :label="item.configName"
                    :value="item.configVal"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="接口标准" prop="interfaceTypeName">
                <el-select
                  class="full-width"
                  v-model="detailForm.interfaceTypeName"
                  size="small"
                  disabled
                >
                  <el-option
                    v-for="item in interfaces"
                    :label="item.configName"
                    :value="item.configVal"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="物联卡号">
                <el-input
                  v-model="detailForm.iotCardNo"
                  size="small"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="资费名称" prop="chargeNo">
                                <el-select class="full-width" v-model="detailForm.chargeNo" size="small" clearable>
                                    <el-option v-for="item in allChargeSelectData" :label="item.chargeName" :value="item.chargeNo" :key="item.id" @click.native="handleChargeChange(item)"></el-option>
                                </el-select>
                                <el-autocomplete
                                    size="small"
                                    class="full-width"
                                    v-model="state"
                                    :fetch-suggestions="querySearchAsync"
                                    placeholder="请输入内容"
                                    @select="handleSelect"
                                ></el-autocomplete>
                            </el-form-item> -->
              <!-- <el-form-item label="私人绑定" v-if="detailForm.optType == '01' && detailForm.userPhone">
                                {{detailForm.userPhone}}
                                <el-button class="margin-left-15" @click="delBind()" size="small" type="primary">解绑</el-button>
                            </el-form-item> -->
            </div>
          </div>
          <div v-for="(item, index) in userPhoneList" :key="index" class="flex detail-form-parent-child-div">
            <span v-if="item.custPhone.length <= 11" class="detail-form-parent-title-div">手机号：</span>
            <span v-if="item.custPhone.length > 11" class="detail-form-parent-title-div">openid：</span>
            {{ item.custPhone }}
            <el-button class="margin-left-15" @click="delBind(item.custPhone)" size="small" type="primary">解绑</el-button>
          </div>
        </el-form>
      </div>
      <div class="detail-content-footer-div">
        <button class="common-bg-button" @click="submitForm('detailForm')">提 交</button>
        <button class="common-empty-button" @click="resetForm">取 消</button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig,
      editFlag: true,
      pageTitle: '充电桩型号新增', //页面标题 // 默认值设置
      detailForm: {}, //  默认表单值
      piletypeEntity: {}, // 查询编辑表单内容
      pileChargeEntity: {}, // 查询编辑表单内容
      dealers: [], //	所有经销商下拉框
      pileTypes: [], //	所有充电商下拉框
      chargingSpeeds: [], //	充电速度下拉框
      optTypes: [], //	桩类型下拉框下拉框
      currentOuts: [], //	电流输出类型下拉框
      interfaces: [], //	接口标准下拉框
      allChargeSelectData: [], //资费名称下拉框
      timeout: null, //	未使用
      state: '', //		未使用(已废弃)
      userPhoneList: [], //需要解绑桩型号
      calcList: [], // 计费方式
    }
  },
  methods: {
      //判断是否为编辑模式
    init() {
      if (this.$store.state.editId) {
        this.pageTitle = '充电桩编辑'
        this.getFormInfo()
        this.getConfig()
      }
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this
      _.$H
        .get(_, _.$A.pile.findByPileCode, { pileCode: _.$store.state.editId }).then((res) => {
          _.detailForm = res.data.data
          if (res.data.data.piletypeEntity) {
            _.piletypeEntity = res.data.data.piletypeEntity
          }
          if (res.data.data.pileChargeEntity) {
            _.pileChargeEntity = res.data.data.pileChargeEntity
            _.detailForm.ttlVal = res.data.data.pileChargeEntity.ttlVal
          }
          _.detailForm.pileTypeCode = _.piletypeEntity.pileTypeCode
          _.detailForm.currentOutTypeName = _.piletypeEntity.currentOutTypeName
          _.detailForm.gunNum = _.piletypeEntity.gunNum
          _.detailForm.chargingSpeed = _.piletypeEntity.chargingSpeed
          _.detailForm.interfaceTypeName = _.piletypeEntity.interfaceTypeName

          _.state = _.detailForm.chargeName
          _.userPhoneList = _.detailForm.userPhoneList
        })
    },
    //获取所有下拉框列表
    getConfig() {
      let _ = this
      //经销商
      _.$H.post(_, _.$A.pile.dealer, {}).then((res) => {
        _.dealers = res.data.data
      })
      //桩型号
      _.$H.post(_, _.$A.pile.type, {}).then((res) => {
        _.pileTypes = res.data.data
      })
      //充电速度
      _.$H.post(_, _.$A.config.list, { configType: '101' }).then((res) => {
        _.chargingSpeeds = res.data.data
      })
      //桩类型
      _.$H.post(_, _.$A.config.list, { configType: '105' }).then((res) => {
        _.optTypes = res.data.data
      })
      //电流输出类型
      _.$H.post(_, _.$A.config.list, { configType: '100' }).then((res) => {
        _.currentOuts = res.data.data
      })
      //接口标准
      _.$H.post(_, _.$A.config.list, { configType: '102' }).then((res) => {
        _.interfaces = res.data.data
      })
      // 计费方式
      _.$H.post(_, _.$A.config.list, { configType: '200' }).then((res) => {
        _.calcList = res.data.data
      })
      // 资费名称
      _.$H.post(_, _.$A.pile.pileCharge, {
          useState: '01',
          corpNo: _.$store.state.corpNo,
        }).then((res) => {
          _.allChargeSelectData = res.data.data
          _.allChargeSelectData.forEach((item) => {
            item.value = item.chargeName
          })
        })
    },
    //选择经销商
    handleDealChange(val) {
      this.detailForm.dealNo = val.dealNo
      this.detailForm.dealName = val.dealName
    },
    //选择充电桩型号名称
    hadlePileTypeChange() {
      this.pileTypes.forEach((item) => {
        if (this.detailForm.pileTypeCode == item.pileTypeCode) {
          this.detailForm.pileTypeNo = item.pileTypeNo
          this.detailForm.pileTypeName = item.pileTypeName
          this.detailForm.chargingSpeed = item.chargingSpeed
          this.detailForm.currentOutTypeName = item.currentOutTypeName
          this.detailForm.gunNum = item.gunNum
          this.detailForm.interfaceTypeName = item.interfaceTypeName
        }
      })
    },
    //选择充电桩型号
    handleOptChange(val) {
      this.detailForm.optType = val.configVal
      this.detailForm.optTypeName = val.configName
    },
    // 选择桩来源
    handleSourceChange() {
      if (this.detailForm.calcWay == '01') {
        this.detailForm.calcWayName = '平台计费'
      } else if (this.detailForm.calcWay == '02') {
        this.detailForm.calcWayName = '桩计费'
      } else {
        this.detailForm.calcWayName = '金额计费'
      }
    },
    //该功能已删除
    handleChargeChange(val) {
      this.detailForm.chargeNo = val.chargeNo
      this.detailForm.chargeName = val.chargeName
      this.detailForm.ttlVal = val.ttlVal
    },
    // 该功能已删除
    querySearchAsync(queryString, cb) {
      var restaurants = this.allChargeSelectData
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants
      clearTimeout(this.timeout)
      // this.timeout = setTimeout(() => {
      cb(results)
      // }, 2000 * Math.random());
    },
    //该功能已删除
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
    //该功能已删除
    handleSelect(item) {
      this.detailForm.chargeNo = item.chargeNo
      this.detailForm.chargeName = item.chargeName
      this.detailForm.ttlVal = item.ttlVal
    },
    // 表单提交
    submitForm(formName) {
      let _ = this
      _.detailForm.corpNo = _.$store.state.corpNo
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.$S.submitForm(_, _.$A.pile.pileEdit, _.editFlag, _.detailForm, pageConfig.listRouter)
        }
      })
    },
    // 取消
    resetForm() {
      this.$router.push({
        name: pageConfig.listRouter,
      })
    },
    //解绑桩
    delBind(val) {
      let _ = this
      var obj = {
        userPhone: val,
        pileCode: _.detailForm.pileCode,
        corpNo: _.$store.state.corpNo,
      }
      _.$H.post(_, _.$A.pile.unBindPile, obj).then((res) => {
        _.$U.success('解绑成功')
        _.getFormInfo()
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
